import { Map as ImmutableMap, List as ImmutableList, fromJS } from 'immutable';

import {
  SCHEDULED_STATUSES_FETCH_REQUEST,
  SCHEDULED_STATUSES_FETCH_SUCCESS,
  SCHEDULED_STATUSES_FETCH_FAIL,
  SCHEDULED_STATUSES_EXPAND_REQUEST,
  SCHEDULED_STATUSES_EXPAND_SUCCESS,
  SCHEDULED_STATUSES_EXPAND_FAIL,
  SCHEDULED_STATUS_DELETE_SUCCESS,
} from '../actions/scheduled_statuses';

const initialState = ImmutableMap({
  items: ImmutableList(),
  isLoading: false,
  loaded: false,
  next: null,
});

export default function scheduledStatuses(state = initialState, action) {
  switch (action.type) {
  case SCHEDULED_STATUSES_FETCH_REQUEST:
  case SCHEDULED_STATUSES_EXPAND_REQUEST:
    return state.set('isLoading', true);
  case SCHEDULED_STATUSES_FETCH_FAIL:
  case SCHEDULED_STATUSES_EXPAND_FAIL:
    return state.set('isLoading', false);
  case SCHEDULED_STATUSES_FETCH_SUCCESS:
    return state.withMutations(mutable => {
      mutable.set('items', fromJS(action.statuses));
      mutable.set('next', action.next);
      mutable.set('isLoading', false);
      mutable.set('loaded', true);
    });
  case SCHEDULED_STATUSES_EXPAND_SUCCESS:
    return state.withMutations(mutable => {
      mutable.update('items', list => list.concat(fromJS(action.statuses)));
      mutable.set('next', action.next);
      mutable.set('isLoading', false);
    });
  case SCHEDULED_STATUS_DELETE_SUCCESS:
    return state.update('items', list => list.filterNot(item => item.get('id') === action.id));
  default:
    return state;
  }
}
